import {Component} from 'react';
import h from 'react-hyperscript';
import './Breadcrumbs.scss';
import {h4} from 'Components/Typography/Typography';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import {REPORT} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
import {ENDPOINTS} from 'Src/utils/utils';

class Breadcrumbs extends Component {
  render() {
    const downloadReport = (e) => {
      e.preventDefault();
      pushGTMEvent(REPORT.TAG, {
        event: REPORT.EVENT,
        action: {report_action: REPORT.ACTION.DOWNLOAD},
      });
      const {reportId} = this.props;
      if (reportId) {
        fetch(ENDPOINTS.REPORT_DOWNLOAD, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': this.props.idToken,
            'X-CSRF-Token': this.props.csrf,
          },
          body: JSON.stringify({
            report_card_id: reportId,
          }),
        });
      }
      window.print();
    };
    return h(
        'div',
        {
          id: 'breadcrumbs',
          className: 'flex--space-between flex--wrap',
        },
        [
          h(
              'div',
              {
                className: 'flex flex--wrap-md',
              },
              [
                h(
                    h4,
                    {
                      className: 'text--grey flex',
                    },
                    [
                      `${this.props.districtName}'s Report`,
                      h(
                          'span',
                          {
                            className: `material-icons text--grey
                            padding-left--micro`,
                          },
                          'keyboard_arrow_right'
                      ),
                    ]
                ),
                h(
                    h4,
                    {
                      id: 'breadcrumbs__report-name',
                    },
                    this.props.reportCardName
                ),
              ]
          ),
          h(
              TooltipGroup,
              {
                title: this.props.reportButton.tooltip,
              },
              [
                h(
                    'span',
                    {
                      className: `button button--flat button--no-padding
                  button--left button--no-max-width`,
                      tabIndex: 0,
                      onClick: downloadReport,
                    },
                    [
                      h(
                          'span',
                          {
                            className: 'material-icons',
                            placement: 'top',
                          },
                          'get_app'
                      ),
                      this.props.reportButton.label,
                    ]
                ),
              ]
          ),
        ]
    );
  }
}

export default Breadcrumbs;
